<template>
  <div id="adminroletree">
    <el-row>
      <el-col :span="12">
        <el-button size="mini" @click="handleAddTop">添加顶级角色</el-button>
        <el-tree
          :data="tree"
          :props="defaultProps"
          node-key="id"
          highlight-current
          :expand-on-click-node="false"
          :default-expanded-keys="expanded"
          :render-content="renderContent"
          @node-click="handleNodeClick"
        >
        </el-tree>
      </el-col>
      <el-col v-loading="loading" :span="12">
        关联权限管理
        <el-button type="primary" size="mini" @click="submitMca()"
          >提交</el-button
        >
        <el-tree
          ref="mcaTree"
          :data="mcaTree"
          node-key="id"
          show-checkbox
          :default-checked-keys="mcaChecked"
          :default-expanded-keys="mcaExpanded"
        >
          <span slot-scope="{ node, data }" class="custom-tree-node">
            <span>{{ node.label }} </span>
            <span>{{ data.id }} </span>
          </span>
        </el-tree>
        <el-button type="primary" size="mini" @click="submitMca()"
          >提交</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Vue from "vue";
import TreeRender from "../components/TreeRender";
export default {
  name: "Adminroletree",
  data() {
    return {
      filterText: "",
      tree: [],
      expanded: [],
      isEdit: true,
      defaultProps: {
        children: "children",
        label: "label",
      },
      mcaTree: [],
      mcaExpanded: [],
      mcaChecked: [],
      mcaRoleId: 0,
      loading: false,
    };
  },
  created() {
    /* 获取菜单列表数据 */
    var _this = this;
    this.$http.post("/erp/AdminRole/getAdminRoleTree").then(function(res) {
      if (res.data.code === 200) {
        _this.tree = res.data.data.tree;
        // _this.initExpand();
      }
    });
  },
  methods: {
    renderContent(h, { node, data, store }) {
      let that = this; //指向vue
      return h(TreeRender, {
        props: {
          DATA: data, //节点数据
          NODE: node, //节点内容
          STORE: store, //完整树形内容
          maxexpandId: that.non_maxexpandId,
        },
        on: {
          //绑定方法
          nodeAdd: (s, d, n) => that.handleAdd(s, d, n),
          nodeEdit: (s, d, n) => that.handleEdit(s, d, n),
          nodeDel: (s, d, n) => that.handleDelete(s, d, n),
          nodeEditPass: (s, d, n) => that.nodeEditPass(s, d, n),
        },
      });
    },
    handleAddTop() {
      this.tree.push({
        id: 0,
        name: "新增节点",
        pid: 0,
        isEdit: true,
        children: [],
      });
    },
    handleAdd(s, d, n) {
      //增加节点
      //添加数据
      d.children.push({
        id: 0,
        label: "子角色",
        pid: d.id,
        isEdit: true,
        children: [],
      });
      //展开节点
      if (!n.expanded) {
        n.expanded = true;
      }
      return;
    },
    handleEdit(s, d, n) {
      //编辑节点
    },
    handleDelete(s, d, n) {
      //删除节点
      let _this = this;
      //有子级不删除
      if (d.children && d.children.length !== 0) {
        this.$message.error("此节点有子级，不可删除！");
        return false;
      } else {
        //删除操作
        let delNode = () => {
          let list = n.parent.data.children || n.parent.data,
            //节点同级数据，顶级节点时无children
            _index = 99999; //要删除的index
          list.map((c, i) => {
            if (d.id == c.id) {
              _index = i;
            }
          });
          let k = list.splice(_index, 1);
          /* 删除节点 */
          k.map((c, i) => {
            /* 向后台请求删除数据 */
            this.$http
              .post("/erp/AdminRole/delRole", {
                role_id: c.id,
              })
              .then(function(res) {
                if (res.data.code !== 200) {
                  _this.$message.error(res.data.msg);
                  return;
                }
                _this.$message.success("删除成功！");
              });
          });
        };
        let isDel = () => {
          _this
            .$confirm("是否删除此节点？", "提示", {
              confirmButtonText: "确认",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {
              delNode(); //此处可通过ajax做删除操作
            })
            .catch(() => {
              return false;
            });
        };
        //新增节点直接删除，否则要通过请求数据删除
        d.id > this.non_maxexpandId ? delNode() : isDel();
      }
    },
    nodeEditPass(s, d, n) {
      //提交通过
      if (!d.label || d.label == "") {
        return;
      }
      /* 向后台请求并保存数据 */
      this.$http
        .post("/erp/AdminRole/save", {
          role_id: d.id,
          role_name: d.label,
          pid: d.pid,
          sort: d.sort,
        })
        .then(function(res) {
          if (res.data.code !== 200) {
            _this.$message.error(res.data.msg);
            return;
          }
          if (res.data.data.info) {
            d.id = res.data.data.info.role_id;
          }
        });
    },
    handleNodeClick(d, n, s) {
      //点击节点
      d.isEdit = false; //放弃编辑状态
      this.loading = true;
      this.initMca(d.id);
    },
    initExpand() {
      this.tree.map(a => {
        this.expanded.push(a.id);
      });
    },
    initMca(id) {
      // 初始关联的权限数据
      var _this = this;
      this.mcaRoleId = id;
      this.$http
        .post("/erp/AdminRole/getAdminRoleToMcaTree", {
          role_id: id,
        })
        .then(function(res) {
          if (res.data.code === 200) {
            _this.mcaTree = res.data.data.tree;
            _this.mcaExpanded = res.data.data.checked;
            _this.$refs.mcaTree.setCheckedKeys(res.data.data.checked);
          }
          _this.loading = false;
          if (res.data.code !== 200) {
            _this.mcaTree = [];
            _this.$message.error(res.data.msg);
            return;
          }
        });
    },
    submitMca() {
      var _this = this;
      /* 提交权限关联数据 */
      this.$http
        .post("/erp/AdminRole/saveAdminRoleJoinMca", {
          role_id: this.mcaRoleId,
          mcas: this.$refs.mcaTree.getCheckedKeys(),
        })
        .then(function(res) {
          if (res.data.code !== 200) {
            _this.$message.error(res.data.msg);
            return;
          }
          if (res.data.code === 200) {
            _this.$message({
              type: "success",
              message: "修改成功!",
            });
            return;
          }
        });
    },
  },
};
</script>

<style scoped>
.expand-tree .is-current > .el-tree-node__content .tree-btn,
.expand-tree .el-tree-node__content:hover .tree-btn {
  display: inline-block;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/pages/AdminRoleTree.vue